var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00511 5.2334L1.0051 5.23339L1.00371 5.23482C0.816305 5.42791 0.821353 5.73555 1.01517 5.92118C1.20314 6.1031 1.50182 6.10299 1.68965 5.92084L1.68966 5.92086L1.69112 5.9194L5.57131 2.03921L9.45352 5.9194C9.64337 6.10925 9.951 6.1104 10.1399 5.91904C10.3294 5.72919 10.3304 5.42187 10.1392 5.23311C10.1391 5.23297 10.139 5.23283 10.1388 5.23269L5.91532 1.00919C5.72547 0.819341 5.41782 0.8182 5.22894 1.00957C5.22883 1.00968 5.22872 1.00979 5.22861 1.00991L1.00511 5.2334Z",
    fill: "#00C6C9",
    stroke: "#00BEC1",
    strokeWidth: 0.267171
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.006b8e9f.svg";
export { ForwardRef as ReactComponent };